import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { PortalTicketCreateFlow } from "@sd/components/DarkThemeWidget/PortalTicketCreateFlow";
import { TicketDialogBackdrop, preventTicketDialogDismiss, ticketDialogOpenChangeHandler } from "@sd/components/tickets/TicketDialogBackdrop";
import "@sd/components/DarkThemeWidget/styles.css";

interface PortalTicketCreateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreated?: (
    ticketRef: string | null,
    meta?: { subject?: string; uiId?: string | null; crNumber?: string | null }
  ) => void;
  /** Pass false when portaled dropdowns must remain clickable (admin panel). */
  modal?: boolean;
}

export function PortalTicketCreateDialog({
  open,
  onOpenChange,
  onCreated,
  modal = true,
}: PortalTicketCreateDialogProps) {
  const [flowKey, setFlowKey] = useState(0);

  useEffect(() => {
    if (open) {
      setFlowKey(k => k + 1);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onOpenChange={ticketDialogOpenChangeHandler(onOpenChange)}
      modal={modal}
    >
      <TicketDialogBackdrop open={open} />
      <DialogContent
        hideOverlay
        {...preventTicketDialogDismiss()}
        className="z-50 flex max-h-[min(92vh,920px)] w-[min(720px,calc(100vw-2rem))] max-w-[720px] flex-col gap-0 overflow-hidden border-border p-0 sm:max-w-[720px] [&>button.absolute]:hidden"
      >
        <DialogHeader className="sr-only">
          <DialogTitle>New Ticket</DialogTitle>
          <DialogDescription>
            Create a ticket using the same flow as the end-user portal.
          </DialogDescription>
        </DialogHeader>

        {open ? (
          <PortalTicketCreateFlow
            key={flowKey}
            embedded
            skipRequesterStep
            agentTheme
            skipSuccessScreen
            onClose={() => onOpenChange(false)}
            onSuccess={(ticketRef, meta) => {
              onCreated?.(ticketRef, meta);
            }}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
